import { IonCol, IonGrid, IonRow } from "@ionic/react";
import React from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "moment-timezone";
import {
	addStatusClass,
	digitChanger,
	monthChanger,
	numberWithCommas,
} from "helpers/helper";
import moment from "moment-timezone";
import Bag from "assets/images/icon/svg/Bag";
import Car from "assets/images/icon/svg/Car";
import EditPen from "assets/images/icon/svg/EditPen";
import Shop from "assets/images/icon/svg/Shop";
import { setFrom } from "redux/container/orderSlice";
import { setSelectedTab } from "redux/container/accountSlice";

export default function EmployeeLeaveStatusCard({ response }) {
	// const response = useSelector((state) => state.order);
	const ekkLanguage = useSelector((state) => state.lan.lan);
	const dispatch = useDispatch();
	const mediaQuery = window.matchMedia("(max-width: 340px)");
	const dateFormat = useSelector((state) => state.date?.format);

	return (
		<>
			<IonGrid>
				<IonRow>
					{response?.length ? (
						response.map((leave, index) => {
							let orderStatus = addStatusClass(leave?.id);

							return (
								<IonCol
									// onClick={() => {
									// 	dispatch(setFrom("orderList"));
									// }}
									size='12'
									key={index}>
									<Link
										onClick={() => {
											dispatch(setSelectedTab(leave?.acc_group));
										}}
										to={`/leave-details/${leave.id}`}>
										<div
											className='mb-2 rounded-[10px] overflow-hidden'
											// style={{
											// 	boxShadow: `0px 5px 15px rgba(0, 0, 0, 0.05)`,
											// }}
										>
											<div
												style={{ backgroundColor: "#f1f1f199" }}
												className={`py-[15px] sm:px-4  px-2`}>
												<ul className='flex items-center justify-between'>
													<li className={`w-[50%] text-left`}>
														<h6 className={`font-normal text-12`}>
															{leave?.emp_name}
														</h6>
													</li>

													<li className={`w-[50%] text-right`}>
														<h6
															className={`font-bold text-10 ${
																leave?.status === "Approved"
																	? "text-success"
																	: leave?.status ===
																	  "Rejected"
																	? "text-primary"
																	: "text-orange-400"
															}`}>
															{leave?.status}
														</h6>
													</li>
												</ul>
												<ul className='flex items-center justify-between'>
													<li className={`w-[50%] text-left`}>
														<h6 className={`font-normal text-10`}>
															{moment(
																leave?.start_date,
																"YYYY-MM-DD"
															).format(dateFormat)}{" "}
															-{" "}
															{moment(
																leave?.end_date,
																"YYYY-MM-DD"
															).format(dateFormat)}
														</h6>
													</li>
													<li className={`w-[50%] text-right`}>
														<h6 className={`font-normal text-10`}>
															Duration: {leave?.duration}
														</h6>
													</li>
												</ul>
											</div>
										</div>
									</Link>
								</IonCol>
							);
						})
					) : (
						<>
							<IonCol size='2'></IonCol>
							<IonCol size='8'>
								<div
									className='text-center flex items-center justify-center'
									style={{ height: "calc(100vh - 420px)" }}>
									<div>
										<img
											className='m-auto mb-[10px] mt-5'
											src='/assets/images/not-found-file.png'
											alt='emptyCard'
										/>
										<p className='text-16 font-normal text-222222 mb-[35px]'>
											{ekkLanguage.orderList.notFound}
										</p>
									</div>
								</div>
							</IonCol>
						</>
					)}
				</IonRow>
			</IonGrid>
		</>
	);
}
